import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Admissionleft from './Admissoinleft';
import { Container, Row, Col, Button,Table } from 'react-bootstrap';
import Fade from 'react-bootstrap/Fade';


function Visvesvaraya_Phd_AdmissionELe() {

    const [datesOpen, setDatesOpen] = useState(true);
    const [guidelinesOpen, setGuidelinesOpen] = useState(false);
    const [categoryOpen, setCategoryOpen] = useState(false);    
    const [areasOpen, setAreasOpen] = useState(false);
    const [eligiblityOpen, setEligiblityOpen] = useState(false);
    const [financialOpen, setFinancialOpen] = useState(false);
    const [sectionOpen, setSectionOpen] = useState(false);
    const [documentsOpen, setDocumentsOpen] = useState(false);
    const [feesOpen, setFeesOpen] = useState(false);
    const [applyonlineOpen, setApplyonlineOpen] = useState(false);
    
    const handleClick = (event) => {
        setDatesOpen(false);
        setGuidelinesOpen(false);
        setCategoryOpen(false);
        setAreasOpen(false);
        setEligiblityOpen(false);
        setFinancialOpen(false);
        setSectionOpen(false);
        setDocumentsOpen(false);
        setFeesOpen(false);
        setApplyonlineOpen(false);
        event(true);
    }

    return (
        <section className="project-detail">
            <Container>
                {/* <> */}
                <Row>
                    <Col md={4} className='c-left custom-padding-color mb-4'>
                        <Admissionleft activeIndex={11} />
                    </Col>

                    <Col md={8} className='c-right'>

                        <div className="c-heading">
                            <h3>Visvesvaraya PhD Scheme for Electronics and IT – Phase II</h3> <br />
                        </div>
                        
                        <Row className='mb-5'>
                            {/* /backup xs={6} sm={4} md={3} lg={3}/ */}
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button className='btn-sm c-button'
                                    onClick={() => handleClick(setDatesOpen)}
                                    aria-controls="example-fade-text"
                                    aria-expanded={datesOpen}>
                                    Dates
                                </Button>
                            </Col>

                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button className='btn-sm c-button '
                                    onClick={() => handleClick(setGuidelinesOpen)}
                                    aria-controls="c-guidelines"
                                    aria-expanded={guidelinesOpen}>
                                    Guidelines
                                </Button>
                            </Col>

                            {/* <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button className='btn-sm c-button '
                                    onClick={() => handleClick(setCategoryOpen)}
                                    aria-controls="c-categoryOpen"
                                    aria-expanded={categoryOpen}>
                                    Categories
                                </Button>
                            </Col> */}

                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button className='btn-sm c-button '
                                    onClick={() => handleClick(setAreasOpen)}
                                    aria-controls="c-areas"
                                    aria-expanded={areasOpen}>
                                    Areas
                                </Button>
                            </Col>

                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button className='btn-sm c-button '
                                    onClick={() => handleClick(setEligiblityOpen)}
                                    aria-controls="c-eligiblity"
                                    aria-expanded={eligiblityOpen}>
                                    Eligiblity
                                </Button>
                            </Col>

                            {/* financial */}
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button className='btn-sm c-button '
                                    onClick={() => handleClick(setFinancialOpen)}
                                    aria-controls="c-financial"
                                    aria-expanded={financialOpen}>
                                    Financial Assistance
                                </Button>
                            </Col>
                            {/* section */}
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button className='btn-sm c-button '

                                    onClick={() => handleClick(setSectionOpen)}
                                    aria-controls="c-fiancial"
                                    aria-expanded={sectionOpen}>
                                    Selection
                                </Button>
                            </Col>
                            {/* Documents */}
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button className='btn-sm c-button '

                                    onClick={() => handleClick(setDocumentsOpen)}
                                    aria-controls="c-document"
                                    aria-expanded={documentsOpen}>
                                    Documents
                                </Button>
                            </Col>

                            {/* Fees */}
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button className='btn-sm c-button '

                                    onClick={() => handleClick(setFeesOpen)}
                                    aria-controls="c-feesopen"
                                    aria-expanded={feesOpen}>
                                    Fees
                                </Button>
                            </Col>

                            {/* Apply Online */}
                            <Col xs={6} sm={4} md={2} lg={2} className="mb-3">
                                <Button className='btn-sm c-button '
                                    onClick={() => handleClick(setApplyonlineOpen)}
                                    aria-controls="c-applyonline"
                                    aria-expanded={feesOpen}>
                                    Apply Online
                                </Button>
                            </Col>

                            

                        </Row>
                        
                        {/* <p><b className="glowing-text"> <Link className="c-link" to="/msphd-admissions" target='_blank'>List of provisionally shortlisted candidates for Written Test/Interview - M.S(R) & Ph.D - September 2024 Notification. - Click here</Link></b> </p> */}

                        {/*dates */}
                    <div>
                        {datesOpen && <Fade in={datesOpen}>
                            <div>
							<p className="c-link glowing-text">Applications are invited from the interested and eligible candidates for admissions in Ph.D. programme under Visvesvaraya Ph.D. Scheme for Electronics and IT – Phase II. </p>
							<p className="c-link glowing-text">Due to technical issues, the admissions portal is temporarily unavailable. We are working to restore the services at the earliest. We regret the inconvenience caused. Kindly try again after some time. </p>


							<h4>About Visvesvaraya PhD Scheme for Electronics and IT</h4>
							<p class="caboutus">Ministry of Electronics and Information Technology (MEITY), Government of India has approved implementation of Phase-II of Visvesvaraya PhD Scheme for Electronics & IT with the objective of enhancing the number of PhDs in the Electronic System Design and Manufacturing (ESDM) and IT/IT Enabled Services (ITES).For more information <Link className="c-link" to="https://tinyurl.com/44p3crsy" target="_blank">Click Here</Link></p>
                            {/* <p class="caboutus">Applications are invited from the interested and eligible candidates for admissions in Ph.D. programme under Visvesvaraya Ph.D. Scheme for Electronics and IT – Phase II. </p> */}
						{/* <p class="caboutus"><em><b> Those candidates who have already applied for PhD admissions for July 2025 cycle are considered for evaluation under this Scheme as well and need not separately apply for this scheme. </b> </em></p> */}
						  {/* <p class="caboutus"><b className="glowing-text"> <Link className="c-link" to="https://files.iittp.ac.in/pdfs/admissions/Visvesvaraya/2025/Visvesvaraya_PhD_Scheme_Flyer_25.pdf" target='_blank'>Visvesvaraya Ph.D. Admission Scheme Flyer 2025 - Click here</Link></b> </p>      */}
                            {/* <p className="fw-bold"> <span className="glowing-text">Orientation Program for Ph.D. Scholars on July 25-26, 2024 - {" "}
                            <Link to={"https://files.iittp.ac.in/pdfs/Orientation/2024/Orientation_Program_MS_PhD_Jul_24.pdf"} target="_blank;" className="c-link"> Click here </Link></span> </p> */}

                                 {/* <span> 
                                    <img src="https://files.iittp.ac.in/images/demo/iit/Other/new.gif" width="30" height="20" />
                                    <Link className='text-maroon' href="https://files.iittp.ac.in/pdfs/admissions/2024/MS_PhD_July_2024_Flyer.pdf" target="_blank;" className='c-link'><b>Ph.D. Admissions for July-2024 Brochure - Click here</b></Link>
                                 </span> */}

                                <Table bordered responsive className='mt-3'>
                                    <thead>
                                        <tr>
                                            <th colSpan="2" className="text-center">
                                                <h4 className="text-primary">Important Dates</h4>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>Opening date and time for online application</td>
                                           
                                                <td><b className="c-link glowing-text">15 October 2026 at 12:00 PM</b></td>
                                        </tr>
                                        <tr>
                                            <td>Closing date and time for online application</td>
                                            
											<td><b className="c-link glowing-text">23 October 2026 up to 5.00 PM</b>
											</td>
                                        </tr>
                                        <tr>
                                            <td>Written Test / Interview</td>
                                            <td><b className="c-link glowing-text">will be updated soon</b></td>
                                                {/* <td><b>	5th November 2024 to 18th November 2024 </b></td> */}
                                        </tr>
                                         <tr>
                                            <td>Announcement of Results</td>
                                            <td><b className="c-link glowing-text">will be updated soon</b></td>
                                                
                                        </tr>
                                        <tr>
                                            <td>Reporting to Campus</td>
                                            <td><b className="c-link glowing-text">will be updated soon</b></td>
                                                {/* <td><s><b>Monday, 2nd December 2024</b></s> <b>Monday, 16th December 2024 (Latest by 9 A.M.) </b><br /><span className="text-primary">(Students may plan to arrive on campus from December 14, 2024 onwards)</span></td> */}
                                        </tr>
                                        <tr>
                                            <td>Date of Orientation Program</td>
                                            <td><b className="c-link glowing-text">will be updated soon</b></td>
                                            
                                        </tr>

                                        {/* <tr>
                                            <td>Commencement of classes</td>
                                            <td><b>Monday, August 04, 2025</b></td>
                                        </tr> */}

                                    </tbody>
                                </Table>
                                    
                                    <b>Please write to <Link to="mailto:admissions@iittp.ac.in" className='c-link'>admissions@iittp.ac.in</Link> or call 0877 250 3532 for any questions or queries regarding admission related matters. </b>
                            </div>
                        </Fade>
                    }
                    </div>


                        {/*Guidelines*/}
                        
                    <div>
                            {guidelinesOpen && <Fade in={guidelinesOpen}>
                                <div className='c-lineheight2dot5'>
                                  
                                        <h4 className="mb-3">Important Guidelines for Visvesvaraya Ph.D. Application</h4>
										
                                    <ol className="list-group list-group-numbered"
                                        
                                        style={{ textAlign: 'justify', fontSize: '12pt' }}>
											{/* <li><b>Those candidates who have already applied for PhD admissions for July 2025 cycle, need not to apply separately for this scheme</b></li> */}
                                            <li>
                                            The link to the online application form is available in the Apply Online tab. After filling out the form, please take a print and keep it for your record.
                                            </li>
                                            <li>
                                                The application fee is as follows:
                                            <ul className='myulcustarrow'>
                                                    <li>
                                                     GEN/EWS/OBC-NCL Male candidates: Rs.400/-
                                                    </li>
                                                    <li>
                                                         GEN/EWS/OBC-NCL Female candidates: Rs.200/-
                                                    </li>
                                                    <li>
                                                     SC/ST and PwD candidates: Rs.200/-
                                                    </li>
                                                </ul>
                                                <p style={{ color: '#2009df' }}>The application fee is non-refundable. Please ensure to save the payment reference number.</p>
                                            </li>
                                            <li>
												A candidate can apply to more than one division among all departments; however, the maximum number of divisions to which he or she can apply is three.
                                            </li>
                                            <li>
												Candidates called for the written test/interview must produce a copy of the application submitted online along with originals and photocopies of the relevant certificates.
                                            </li>
                                            <li>
                                        	Reservation/concession/relaxations for EWS/OBC-NCL/SC/ST/PwD and Kashmiri- Migrants (KM), including Kashmiri Pandits/Kashmiri Hindu Families: As per the Government of India rules. A copy of a valid OBC-NCL/ST/SC/EWS/PwD certificate must be uploaded during the ONLINE application and must be submitted at the time of admission.
                                            </li>
                                            <li>
                                            A Statement of Purpose (SoP) must be uploaded along with the online application. The guidelines for preparing the SoP are available at this <Link to="https://files.iittp.ac.in/pdfs/admissions/2023/docx/1.docx" target="_blank" rel="noopener noreferrer">Link</Link>.
                                            </li>
                                            <li>
                                            At the time of physical reporting to the Institute, candidates must submit self-attested copies of the relevant certificates as specified in the Documents tab, failing which admission will stand cancelled.
                                            </li>
                                            <li>
                                            Please make all files ready with following format and size before going to file upload: 
                                            <ul className='myulcustarrow'>
                                                    <li> Passport size Photo (jpg, jpeg, png), size &lt;=500 KB</li>
                                                    <li> Signature (format jpg, jpeg, png) size &lt;= 200 KB</li>    
                                                    <li> 10th Certificate (pdf) size &lt;=1024 KB</li>
                                                    <li> 12th / Diploma / Equivalent Certificate (pdf) size &lt;=1024 KB</li>
                                                    <li> Qualifying UG Degree Certificate (pdf) size &lt;=1024 KB</li>
                                                    <li> Consolidated UG mark sheet (pdf) size &lt;=1024 KB</li>
                                                    <li> Qualifying PG Degree Certificate (pdf) size &lt;=1024 KB</li>
                                                    <li> Consolidated PG mark sheet (pdf) size &lt;=1024 KB</li>
                                                    <li> Community Certificate if applicable (pdf) size &lt;= 1024 KB</li>
                                                    <li> PwD Certificate if applicable (pdf) size &lt;= 1024 KB</li>
                                                    <li> Applicable National Level Exams/GATE (pdf, jpg, jpeg) each size &lt;= 1024 KB</li>
                                                    <li> SoP/Research Proposal, (pdf) size &lt;=1024 KB</li>
                                                    <li> First page of publication, if applicable (pdf, jpg, jpeg) each size &lt;= 1024 KB</li>
                                                </ul>
                                                <p><b>Additional documents for Part Time Candidates</b></p>
                                                <ul className='myulcustarrow'>
                                                    <li> Proof of Employment such as Identity Card/latest salary statement (pdf) size &lt;= 1024 KB</li>
                                                    <li> No-Objection Certificate or Undertaking 
                                                        <ul className='myulcustarrow'>
                                                         <li>Format for NOC:  <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/NoC_External_Parttime.docx" target="_blank" rel="noopener noreferrer">Link</Link>, (pdf) size &lt;=1024 KB</li>
                                                            <li>Format for Undertaking:  <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/Undertaking.docx" target="_blank" rel="noopener noreferrer">Link</Link>, (pdf) size &lt;=1024 KB</li>
                                                         </ul>
                                                         </li>
                                                </ul>
                                            </li>
                                            <p><b>Note: Candidate must produce NoC at the time of Written Test / Interview</b></p>
                                            <li>
                                            	Please visit the institute’s website regularly for important announcements and results.
                                            </li>
                                            <li>
                                                In case of any queries, please write to{' '}
                                            <Link to="mailto:admissions@iittp.ac.in" className='c-link'>admissions@iittp.ac.in</Link> or call 0877 250 3532 (9.00 AM to 5.30 PM on all working days).
                                            </li>
                                        </ol>
                                  
                            </div>
                        </Fade>
                    }
                </div>


                        {/*Categoies*/}

                        <div>
                        {categoryOpen && <Fade in={categoryOpen}>
                                <div className='c-lineheight2dot5'>

                                    <h4 className="mb-3">Ph.D. admissions are made under various modes as mentioned below:</h4>
                                    
                                    <ul className="">
                                        <li>
                                        <b>1. Regular-HTRA/Project:</b> Scholars funded by Half-Time Research Assistantship (HTRA) or a Project administered by CSRC, IITT.
                                        </li>
                                    </ul>
                                   
                                    <ul className="">
                                        <li class="caboutus">
                                        <b> 2.	Regular-Fellowship:</b> Scholars funded by outside agencies such as UGC, CSIR, PMRF, etc.</li>
                                        <li class="caboutus"><b>3.	Part-Time:</b>
                                            <ul className='myulcustarrow caboutus'>

                                         
                                                    <li> The applicant must be employed in an industry, organization or institution located within commutable distance of IIT Tirupati.</li>
                                                    <li> The applicant should have at least two years of professional experience as on the last date of receipt of applications.</li>
                                                    <li> The following documents are required along with the application
                                                    <ul className='myulcustarrow'>
                                                    <li> Proof of Employment such as Identity Card/latest salary statement (pdf) size &lt;= 1024 KB</li>
                                                    <li> No-Objection Certificate or Undertaking 
                                                        <ul className='myulcustarrow'>
                                                         <li>Format for NOC:  <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/NoC_External_Parttime.docx" target="_blank" rel="noopener noreferrer">Link</Link>, (pdf) size &lt;=1024 KB</li>
                                                            <li>Format for Undertaking:  <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/Undertaking.docx" target="_blank" rel="noopener noreferrer">Link</Link>, (pdf) size &lt;=1024 KB</li>
                                                         </ul>
                                                         </li>
                                                </ul>
                                                        
                                                    </li>

                                                    <li> The following documents are required at the time of admission
                                                    <ul className='myulcustarrow caboutus'>
                                                        {/* <li>Certificate of Support from the Employer</li> */}
                                                        <li>Relieving (Leave)  Certificate from the Employer: <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/Relieving_Certificate.docx" target="_blank;" className='c-link'>Link</Link></li>
                                                        </ul>
                                                    </li>
                                        
                                            </ul>  
                                        </li>   
                                    </ul>
                                    <p><b>Note: Candidate must produce NoC at the time of Written Test / Interview</b></p>

                                    <ul>
                                        <li>
                                            <b>  4. External: </b>

                                            <ul className='myulcustarrow caboutus'>
                                                <li> The applicant must be sponsored by and employed in an industry/organization/national laboratory having R&D facilities and recognized by DST or DSIR or IITT.</li>
                                                <li> The applicant must be regular employee and have at least two years of professional experience as on the last date of receipt of applications.</li>
                                                <li> Research scholars admitted under this category will normally carry out part or all their research in the parent organization under supervision of a faculty from IIT Tirupati and a co-supervisor employed in their parent organization.</li>

                                                <li> The following documents are required at the time of application
                                                <ul className='myulcustarrow'>
                                                    <li> Proof of Employment such as Identity Card/latest salary statement (pdf) size &lt;= 1024 KB</li>
                                                    <li> No-Objection Certificate or Undertaking 
                                                    <ul className='myulcustarrow'>
                                                         <li>Format for NOC:  <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/NoC_External_Parttime.docx" target="_blank" rel="noopener noreferrer">Link</Link>, (pdf) size &lt;=1024 KB</li>
                                                            <li>Format for Undertaking:  <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/Undertaking.docx" target="_blank" rel="noopener noreferrer">Link</Link>, (pdf) size &lt;=1024 KB</li>
                                                         </ul>
                                                         </li>
                                                </ul>
                                                </li>
                                                <li> The following documents are required at the time of admission
                                                    <ul className='myulcustarrow caboutus'>
                                                        <li>Certificate of Support from the Employer</li>
                                                        <li>Relieving (Leave) Certificate from the Employer: <a href="https://files.iittp.ac.in/pdfs/admissions/2024/sep/Relieving_Certificate.docx" target="_blank;" className='c-link'>Link</a></li>
                                                    </ul>
                                                </li>
                                            </ul>

                                        </li>
                                    </ul> 
                                    <p><b>Note: Candidate must produce NoC at the time of Written Test / Interview</b></p>

                                    {/* <ul>
                                        <li>
                                            <b>  5. Internal (IIT Tirupati Staff): </b>

                                            <ul className='myulcustarrow caboutus'>
                                                <li> Permanent employees of IITT with at least two years of work experience</li>
                                                <li> The applicant should have at least two years of experience as a regular employee as on the last date of receipt of applications.</li>
                                                <li><b>Candidate must produce NoC at the time of Written Test / Interview</b></li>
                                            </ul>
                                        </li>
                                    </ul> */}

                                   
                                    <ul>
                                        <li>
                                            <b> Note: </b>

                                            <ul className='myulcustarrow caboutus'>
                                                <li> The minimum residential requirement for the Ph.D. research scholars under External/Part-time category of admission is one semester.</li>
                                                <li> Candidates admitted under Non-HTRA category cannot be moved to HTRA category at a later date.</li>
                                                <li> More details on External/Part-time category of admission, including any questions regarding the recognition of the organization/laboratory might be addressed to the Head of the department of interest or <Link className='c-link' to="mailto:admissions@iittp.ac.in">admissions@iittp.ac.in</Link> </li>
                                            </ul>
                                        </li>
                                    </ul>


                                </div>
                            </Fade>
                            }
                        </div>


                        {/*Areas*/}

                        <div>
                            {areasOpen && <Fade in={areasOpen}>
                        <div>
							<p>A Statement of Purpose (SoP) must be uploaded along with the online application. The guidelines for preparing the SoP are available at this Link.<Link className='c-link' to="https://files.iittp.ac.in/pdfs/msphd/admissions/SoP.pdf">Click here</Link></p>
                            <h4 className='mb-4'>Areas of Research</h4>
							<h4 className='mb-4'>Computer Science and Engineering</h4>
                            <ul className='myulcustarrow'>
                                <li> Theoretical Computer Science</li>
                                <li> Microelectronics & VLSI</li>
                                <li> AI/ML</li>
                                <li> IoT</li>
                                <li> High-Performance Computing</li>
                            </ul>
							<h4 className='mb-4'>Electrical Engineering</h4>
                            <ul className='myulcustarrow'>
                                <li> Microelectronics,Microelectronics & VLSI</li>
                               <li> Power Engineering</li>
                            </ul>
							<h4 className='mb-4'>Physics</h4>
                            <ul className='myulcustarrow'>
                                <li> Photonics</li>
                            </ul>

                                    {/* Table */}
                                    {/* <Table bordered responsive className='mt-3 c-table'>
                                        <colgroup>
                                            <col style={{ width: '20%' }} /> 
                                            <col style={{ width: '20%' }} />
                                            <col style={{ width: '30%' }} />
											 <col style={{ width: '30%' }} />
                                        </colgroup>
                                        <tbody> */}
                                            {/* Table header */}
                                            {/* <tr>
                                                <td><b>Department</b></td>
                                                <td><b>Division</b></td>
                                                <td><b>Areas of Research</b></td>
												<td><b>Additional Information</b></td>
                                            </tr> */}
                                            {/* Table rows */}
                                            {/* Row 1 */}
                                            {/* <tr>
		<td rowSpan="32" >Chemical Engineering</td>
		<td rowSpan="32" >Chemical Engineering</td>
		<td >General Chemical Engineering</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td > Lignin to Chemicals</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td > Microfluidics</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td > Aqueous two-phase extraction</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Process Control</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Machine Learning for material synthesis and characterization</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Machine learning and optimization</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Artificial Intelligence-driven Process Modelling and Monitoring</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Computer vision</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Water distribution and optimization</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Supply chain management</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Computational Fluid Dynamics</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Desalination</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Multiphase flow</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Granular Flow*</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Liquid-Liquid Extraction</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Material Synthesis with Microreactors</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Battery recycling</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Computationally engineered nanomaterials</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Corrosion Studies</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Surface and interface engineering</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Hybrid super capacitors</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td > Materials for Gas Separation</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Molecular simulations</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Sodium ion battery</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Soft matter and food colloids</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Electrocatalysis for green hydrogen production*</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Tissue engineering</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Nanobiotechnology</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td > Food processing and technology</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Chemical and Biosensors</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Process synthesis and design</td>
		<td ><br /></td>
	</tr> */}
	{/* <tr>
		<td rowSpan="12" >Civil and Environmental Engineering</td>
		<td rowSpan="4" >Environmental Engineering</td>
		<td >Air Quality Modelling and Management</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Capacitive Deionization</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Sustainability and Life Cycle Analysis</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Wastewater Treatment and Management</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td rowSpan="2" >Geotechnical Engineering</td>
		<td >Rock Mechanics</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Geotechnical Engineering</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Structural Engineering</td>
		<td >All major areas in Structural Engineering</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Transportation Engineering</td>
		<td >Transportation Engineering</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td rowSpan="2" >Water Resources Management</td>
		<td >Water Resources Management </td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >GIS &amp; Remote Sensing</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td rowSpan="2" >Construction Materials and Technology</td>
		<td >Special Concretes</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Durability of Concrete Structures</td>
		<td ><br /></td>
	</tr> */}
	{/* <tr>
		<td rowSpan="21" >Computer Science and Engineering</td>
		<td rowSpan="21" >Computer Science and Engineering</td>
		<td >Parallel Computing</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >High Performance Computing</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Quantum System Architecture</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >ML for IoTs</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Computer Networks</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Algorithms and Data Structures</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >AI and Software Engineering </td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Responsible Computing for Society</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Cyber Security and AI</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Reinforcement Learning</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Multi Agent Systems</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Algorithms and Complexity</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Computer Vision</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Deep Learning for Autonomous Vision</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Processor Design</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >VLSI Design and Test</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >AI Accelerator</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Human-Computer Interaction</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >LLMs for IoTs</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Cryptography and Data Privacy</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Computing for Education</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td rowSpan="15" >Electrical Engineering</td>
		<td rowSpan="2" >Power and Control</td>
		<td >Power Electronics </td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Control and Robotics </td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Semiconductor Devices</td>
		<td >Semiconductor Devices </td>
		<td ><br /></td>
	</tr>
	<tr>
		<td rowSpan="2" >VLSI</td>
		<td >Analog and Mixed Signal Integrated Circuit Design</td>
		<td rowSpan="2" ><br /></td>
	</tr>
	<tr>
		<td >VLSI Design (Processor Design and Hardware Security)</td>
		</tr>
	<tr>
		<td rowSpan="3" >Signal Processing &amp; Machine Learning</td>
		<td >Deep Learning for Medical Imaging</td>
		<td rowSpan="3" style={{textAlign:'center', verticalAlign:'middle'}}>Eligible applicants include those with a UG/PG degree in EE, EC, CS, Data Science and AI, or any related field</td>
	</tr>
	<tr>
		<td >Deep Learning for Computer Vision</td>
		</tr>
	<tr>
		<td >Deep Learning for Speech Processing</td>
		</tr>
	<tr>
		<td rowSpan="4" >RF &amp; Microwaves</td>
		<td >Advanced Antenna Systems and Base Station</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >RF and Microwave Components </td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Metamaterials and RF Sensing </td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >RF and mm-wave Integrated Circuit Design</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td rowSpan="3" >Next-Generation Wireless Communications <br />and Networks</td>
		<td >Communication Networks for 6G and Beyond</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Machine learning for Wireless Communication </td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Quantum Information and Communication Theory</td>
		<td ><br /></td>
	</tr> */}
	{/* <tr>
		<td rowSpan="44">Mechanical Engineering</td>
		<td rowSpan="15" >Manufacturing </td>
		<td >Polymers Engineering</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Composite 3D Printing</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Abrasive Fluids Development</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Micromachining</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Finishing Processes</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Advanced Machining Processes</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Intelligent Manufacturing System</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Metal Forming*</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Surface Engineering and Simulation*</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Industrial Robotics and Automation</td>
		<td >Candidates from Electrical/ Electronics/ Mechanical/ Computer science/ Mechatronics/ Instrumentation backgrounds are encouraged to apply</td>
	</tr>
	<tr>
		<td >4D Printing</td>
		<td >Candidates from Electrical/ Electronics/ Mechanical/ Computer science/ Mechatronics/ Instrumentation backgrounds are encouraged to apply</td>
	</tr>
	<tr>
		<td >Advanced Metal Casting*</td>
		<td >Candidates from Mechanical/ Materials Science and Metallurgical Engineering/Computational Materials Science backgrounds are encouraged to apply</td>
	</tr>
	<tr>
		<td >Smart manufacturing</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Thermal-metallurgical-mechanical modeling of the metal additive manufacturing process using CFD-FEM framework.</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Digital twin for the hybrid twin wire arc additive manufacturing process</td>
		<td >Candidates from Mechanical/ Mechatronics/ Aerospace Engineering/ Materials Science and Metallurgical Engineering backgrounds are encouraged to apply</td>
	</tr>
	<tr>
		<td >Dynamics and Control</td>
		<td >Orbital mechanics and flight dynamics</td>
		<td >Candidates from Mechanical or Aerospace Engineering background are encouraged to apply.</td>
	</tr>
	<tr>
		<td rowSpan="18" >Fluids and Thermal Engineering</td>
		<td >Hydrogen storage and Sorption heating and cooling systems.</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Wind energy</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Experimental and computational fluid mechanics/aerodynamics.</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Interfacial flows</td>
		<td >Candidates from Mechanical, Chemical, Aerospace, and Mathematics backgrounds are encouraged to apply</td>
	</tr>
	<tr>
		<td >Flow instability</td>
		<td >Candidates from Mechanical, Chemical, Aerospace, and Mathematics backgrounds are encouraged to apply</td>
	</tr>
	<tr>
		<td >Surfactant dynamics</td>
		<td >Candidates from Mechanical, Chemical, Aerospace, and Mathematics backgrounds are encouraged to apply</td>
	</tr>
	<tr>
		<td >Wave hydrodynamics</td>
		<td >Candidates from Mechanical, Chemical, Aerospace, and Mathematics backgrounds are encouraged to apply</td>
	</tr>
	<tr>
		<td >CFD</td>
		<td >Candidates from Mechanical, Chemical, Aerospace, and Mathematics backgrounds are encouraged to apply</td>
	</tr>
	<tr>
		<td >hydrogen combustion</td>
		<td >Candidates from Mechanical, Chemical, Aerospace, and Mathematics backgrounds are encouraged to apply</td>
	</tr>
	<tr>
		<td >Spray and combustion modeling</td>
		<td >Candidates from Mechanical, Chemical, Aerospace, and Mathematics backgrounds are encouraged to apply</td>
	</tr>
	<tr>
		<td >IC Engine and Gas turbine modeling</td>
		<td >Candidates from Mechanical, Chemical, Aerospace, and Mathematics backgrounds are encouraged to apply</td>
	</tr>
	<tr>
		<td >Novel algorithms for CFD</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Thermal management in Electric Vehicles using 3D printed lattice structure and Phase change Materials</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Development of large scale hydrogen stroage and purification system</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >IC Engines operating with hydrogen blends</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Sprays and combustion</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Multiphase flows</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Fluid-Structure Interaction</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td rowSpan="5" >Robotics and Control</td>
		<td >Design, control and digital twins for fleet of Underwater Robots</td>
		<td rowSpan="5" style={{textAlign:'center', verticalAlign:'middle'}}>Candidates with background in Electrical/ Electronics/ Mechanical/ Computer science/ Mechatronics/ Instrumentation are encouraged to apply</td>
	</tr>
	<tr>
		<td >Robots for Construction Automation and 3D Printing of Concrete Structures</td>
		</tr>
	<tr>
		<td >Drone swarms and docking stations for drones</td>
		</tr>
	<tr>
		<td >Robots for Food Processing and preservation</td>
		</tr>
	<tr>
		<td >Mechatronic system for road quality assessment</td>
		</tr>
	<tr>
		<td rowSpan="5" >Solid Mechanics</td>
		<td >Plasticity and phase transformations</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Biomechanics</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Composite Materials</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Dynamics</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Computational Mechanics</td>
		<td >Preferably GATE qualified</td>
	</tr> */}
	{/* <tr>
		<td rowSpan="22" >Chemistry</td>
		<td rowSpan="3" >Physical Chemistry</td>
		<td >Fluorescence spectroscopy and microscopy</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Biophysical Chemistry</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Chemical Biology</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td rowSpan="2" >Theoretical and Physical Chemistry</td>
		<td rowSpan="2" >Stochastic Modelling of Autocatalyis and Chemical Oscillations, Stochastic Thermodynamics and Information Engines, Stochastic Restarts in Biophysical Processes</td>
		<td rowSpan="2" ><br /></td>
	</tr>
	<tr>
		</tr>
	<tr>
		<td rowSpan="5" >Organic Chemistry</td>
		<td >Asymmetric Total Synthesis of Bioactive Natural Porducts and Drug Intermediates</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Organic Synthesis: C-H Activation, Photocatalysis, Electrocatalysis, Mechanochemistry</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Organocatalysis applications in carbohydrate chemistry</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Total synthesis of bacterial, fungal glycans</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Asymmetric Catalysis, 3D-Transition Metal Catalysis, and Photoredox Catalysis</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td rowSpan="7" >Inorganic Chemistry</td>
		<td >Boron incorporated organic functional materials</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Redox chemistry, Bioinspired and biomimetic reactions of transition metal complexes</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Supramolecular chemistry of interlocked molecules</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Transition metal-oxide cluster chemistry for the development of energy storage systems</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Electrochemistry and development of redox flow battery systems</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Main Group Organometallic Chemistry</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Coordination Chemistry, Bioinorganic Chemistry, and Environmental Chemistry</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td rowSpan="2" >Medicinal Chemistry</td>
		<td >Medicinal Chemistry and Anticancer Drug discovery</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Chemical Biology and Bioorganic Chemistry</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Physical Chemistry and Inorganic Chemistry</td>
		<td >Sustainable Battery Development with Tailor-Made Electrodes</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td rowSpan="2" >Computational Chemistry</td>
		<td >Computational Modelling of Materials for Green Energy Generation (Photovoltaics) and Storage (Battery)</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Computational Chemistry and Soft-Matter: Small Molecules, Materials, Proteins, and Machine Learning</td>
		<td ><br /></td>
	</tr> */}
	{/* <tr>
		<td rowSpan="9" >Physics</td>
		<td rowSpan="5" >Theoretical Physics</td>
		<td >Plasma-kinetic modlling, quantum mechnical calculations of atomic systems*</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Condensed matter theory*</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Atomic, molecular and optical physics, ultrafast quantum dynamics</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Astrophysics of galaxies and intergalactic medium including both observations and theory.</td>
		<td >Experience in astrophysics research or computational work with Python is desirable.</td>
	</tr>
	<tr>
		<td >Condensed matter theory, computational physics</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td rowSpan="4" >Experimental Physics</td>
		<td >Design and development of cold plasma reactor and its performance optimization using time-space resolved spectroscopy and imaging techniques*</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td ><br />Experimental atomic physics and experimental quantum optics for cold atom-based research in quantum communication and quantum memories*</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Quantum photonics, quantum sensing, quantum communication and networking (with solid state qubits), spintronics</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Strongly correlated electron systems, complemented with first principle calculations</td>
		<td ><br /></td>
	</tr> */}
	{/* <tr>
		<td rowSpan="11" >Mathematics and Statistics</td>
		<td rowSpan="6" >Mathematics</td>
		<td >Numerical Partial Differential Equations</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Analysis (Fractal)</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Functional Analysis (Fixed Point Theory)</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Number Theory</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Partial Differential Equations</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Inverse Problems</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td rowSpan="5" >Statistics</td>
		<td >Statistical Inference</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Design of Experiments</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Time Series Analysis</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Spatio-Temporal Models*</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Reliability and Survival Analysis*</td>
		<td ><br /></td>
	</tr> */}
	{/* <tr>
		<td rowSpan="25">Humanities and Social Sciences</td>
		<td rowSpan="5" >Organizational Behavior/HRM</td>
		<td >Employee Well-Being*</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Positive Organizational Behavior*</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Sustainability and HRM*</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Academic Leadership*</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Decent Work*</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td rowSpan="7" >Economics</td>
		<td >Political Economy</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Development Economics</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Natural Resource &amp; Environmental Economics</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Economics of Natural Disasters &amp; Climate Change</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Energy Economics</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Behavioural Economics</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Financial Economics</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td rowSpan="5" >Operations Management/Industrial Engineering</td>
		<td >Supply Chain Management</td>
		<td >Additional qualifications (UGC&ndash;NET or JRF/CSIR-JRF/GATE) are not mandatory for those possessing an M.E/M.Tech/M.S by Research in Engineering / 5-year integrated Master/Dual Degree in Engineering.</td>
	</tr>
	<tr>
		<td >Reliability Engineering &amp; Maintenance Management</td>
		<td >Additional qualifications (UGC&ndash;NET or JRF/CSIR-JRF/GATE) are not mandatory for those possessing an M.E/M.Tech/M.S by Research in Engineering / 5-year integrated Master/Dual Degree in Engineering.</td>
	</tr>
	<tr>
		<td >Production Planning &amp; Control</td>
		<td >Additional qualifications (UGC&ndash;NET or JRF/CSIR-JRF/GATE) are not mandatory for those possessing an M.E/M.Tech/M.S by Research in Engineering / 5-year integrated Master/Dual Degree in Engineering.</td>
	</tr>
	<tr>
		<td >Project Management</td>
		<td >Additional qualifications (UGC&ndash;NET or JRF/CSIR-JRF/GATE) are not mandatory for those possessing an M.E/M.Tech/M.S by Research in Engineering / 5-year integrated Master/Dual Degree in Engineering.</td>
	</tr>
	<tr>
		<td >Applications of Operations Research, Statistics and Machine Learning in Operations Management</td>
		<td >Additional qualifications (UGC&ndash;NET or JRF/CSIR-JRF/GATE) are not mandatory for those possessing an M.E/M.Tech/M.S by Research in Engineering / 5-year integrated Master/Dual Degree in Engineering.</td>
	</tr>
	<tr>
		<td rowSpan="3" >Philosophy </td>
		<td >Moral Philosophy *</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Social and Political Philosophy *</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td >Modern Indian Philosophy *</td>
		<td ><br /></td>
	</tr>
	<tr>
		<td rowSpan="5" >Urban and Regional Planning</td>
		<td >Urban and Transportation Planning</td>
		<td >Additional qualifications (UGC&ndash;NET or JRF/CSIR-JRF/GATE) are not mandatory for those possessing an M.E/M.Tech/M.S by Research in Engineering / 5-year integrated Master/Dual Degree in Engineering.</td>
	</tr>
	<tr>
		<td >Urban Informatics and Spatial Analytics</td>
		<td >Additional qualifications (UGC&ndash;NET or JRF/CSIR-JRF/GATE) are not mandatory for those possessing an M.E/M.Tech/M.S by Research in Engineering / 5-year integrated Master/Dual Degree in Engineering.</td>
	</tr>
	<tr>
		<td >Urban Planning and Policies</td>
		<td >Additional qualifications (UGC&ndash;NET or JRF/CSIR-JRF/GATE) are not mandatory for those possessing an M.E/M.Tech/M.S by Research in Engineering / 5-year integrated Master/Dual Degree in Engineering.</td>
	</tr>
	<tr>
		<td >Migration and Development</td>
		<td >Additional qualifications (UGC&ndash;NET or JRF/CSIR-JRF/GATE) are not mandatory for those possessing an M.E/M.Tech/M.S by Research in Engineering / 5-year integrated Master/Dual Degree in Engineering.</td>
	</tr>
	<tr>
		<td >Urban Economics and Finance</td>
		<td >Additional qualifications (UGC&ndash;NET or JRF/CSIR-JRF/GATE) are not mandatory for those possessing an M.E/M.Tech/M.S by Research in Engineering / 5-year integrated Master/Dual Degree in Engineering.</td>
	</tr>                                */}

                                         


                                            {/* End of table rows */}
                                        {/* </tbody>
                                    </Table> */}

                                {/* <p className='fw-bold text-info'><em>*These research areas available ONLY under UGC/CSIR/INSPIRE/NBHM/other JRFs scheme. Candidates must possess a valid fellowship for JRF.</em></p> */}
                                </div>
                            </Fade>
                            }
                        </div>



                        {/*Eligiblity*/}

                        <div>
                            {eligiblityOpen && <Fade in={eligiblityOpen}>
                                <div>
                                    <h4 className='mb-4'>Eligibility Criteria</h4>
                                    <p class="caboutus">Candidates seeking admission to the Visvesvaraya PhD Scheme for Electronics and IT – Phase II in different disciplines are required to meet the minimum eligibility criteria regarding their educational qualifications and any additional qualifying exams, as outlined in the following table:</p>
                                    <Table bordered responsive className='mt-3 c-table' >
                                        <tbody>
                                           {/* <tr>
                                                <td colSpan="4">
                                                 <b>Minimum Qualifications for Admission to the Regular Ph.D program</b>
                                                    Candidates applying for the Ph.D program in one of the following areas need to have any one of the minimum qualifications mentioned in the table below:
                                                </td>
                        </tr> */}
                                            <tr>
                                                {/* <td rowSpan="2">
                                                    <b>
                                                    Discipline
                                                    </b>
                                                </td> */}
                                                <td colSpan="3" >
                                                    <b>
                                                    Minimum Qualifications for Ph.D. Admission for Full Time Ph.D. Admission
                                                    </b>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td width="65" >
                                                    <b>
                                                        S. No.
                                                    </b>
                                                </td>
                                                <td >
                                                    <b>
                                                        Educational Qualifications
                                                    </b>
                                                </td>
                                                <td >
                                                    <b>
                                                    Additional Requirements
                                                    </b>
                                                </td>
                                            </tr>
                                            <tr>
                                                {/* <td rowSpan="5" height="422" valign="middle">
                                                    <b>
                                                        Engineering
                                                    </b>
                                                </td> */}
                                                <td >
                                                    <b>
                                                        1
                                                    </b>
                                                </td>
                                                <td >

                                                    M.E/M.Tech/MS(R) in Engineering <br /><br /><p style={{textAlign:'center'}}>(or)</p>
                                                    5-year integrated Master’s degree in Engineering/ B.Tech + M.Tech Dual Degree<br /><br /><p style={{textAlign:'center'}}>(or)</p>
                                                    5-year integrated degree or B.S+M.S from CFTI<br /><br /><p style={{textAlign:'center'}}>(or)</p>
                                                    Master’s degree in Sciences/Humanities and Social Sciences/Management from IITs with a minimum CGPA of 8.0 on a 10.0 point scale (7.5 for EWS/OBC-NCL and 7.0 for SC/ST/PwD)


                                                </td>
                                                <td style={{textAlign:'center', verticalAlign:'middle'}}>
                                                    None
                                                </td>
                                            </tr>
                                            <tr>
                                                <td >
                                                    <b>
                                                        2
                                                    </b>
                                                </td>
                                                <td >
                                                    Master's degree in the relevant Sciences/Humanities and Social Sciences/Management from any recognized university/institute.
                                                </td>
                                                <td >

                                                National Level Eligibility Test (NLT) such as GATE /UGC-NET/CSIR-NET/NBHM/  INSPIRE/JEST or an equivalent one tenable at the time of admission.


                                                </td>
                                            </tr>
                                            {/* <tr>
                                                <td >
                                                    <b>
                                                        3
                                                    </b>
                                                </td>
                                                <td >
                                                Master's degree in the relevant Sciences/Humanities and Social Sciences/Management from any recognized university/institute without a National Level Eligibility Test (NLT) for PhD.
                                                </td>
                                                <td >
                                                (i)	Candidates with more than 5 years of relevant experience after the Master's <br /><br /><p style={{textAlign:'center'}}>(or)</p>
                                                (ii) Candidates with a Master’s degree from CFI other than IITs with a minimum CGPA of 8.0 on a 10.0 point scale (7.5 for EWS/OBC-NCL and 7.0 for SC/ST/PwD) <br /><br /><p style={{textAlign:'center'}}>(or)</p>
                                                (iii) Candidates qualified in the international-level post-graduate admission examination, such as the GRE.
                                                </td>
                                            </tr> */}
                                            <tr>
                                                <td >
                                                    <b>
                                                        3
                                                    </b>
                                                </td>
                                                <td >
                                                4-year Bachelor’s degree from a CFTI with a minimum CGPA of 8.0 on a 10.0 point scale (7.5 for EWS/OBC-NCL and 7.0 for SC/ST/PwD)
                                                </td>
                                                <td style={{textAlign:'center', verticalAlign:'middle'}}>
                                                    None
                                                </td>
                                            </tr>
                                            <tr>
                                                <td >
                                                    <b>
                                                        4
                                                    </b>
                                                </td>
                                                <td >
                                                4-year Bachelor's degree from any recognized university/institute with a minimum CGPA of 7.0 on a 10.0 point scale (6.5 for EWS/OBC- NCL and 6.0 for SC/ST/PwD)

                                                </td>
                                                <td style={{textAlign:'center', verticalAlign:'middle'}}>
                                                GATE tenable at the time of admission
                                                </td>
                                            </tr>
                                          {/*  <tr>
                                                <td rowSpan="5" valign="middle">
                                                    <b>
                                                        Sciences
                                                    </b>
                                                </td>
                                                <td >
                                                    <b>
                                                        6
                                                    </b>
                                                </td>
                                                <td >

                                                    • M.E/M.Tech or M.S by Research in engineering <br />(or)<br />
                                                    • 2 year M.Sc from IITs (entry through JAM) with a minimum CGPA of 8.0 on 10.0 point scale (7.5 for EWS/OBC-NCL and 7.0 for SC/ST/PwD) <br />(or)<br />
                                                    • B.S+M.S, or 5-year integrated degree from CFTI

                                                </td>
                                                <td >
                                                    None
                                                </td>
                                             </tr>
                                            <tr>
                                                <td >
                                                    <b>
                                                        7
                                                    </b>
                                                </td>
                                                <td >

                                                    • M.Sc from IITs without minimum CGPA 8.0 on a 10.0 point scale (7.5 for EWS/OBC-NCL and 7.0 for SC/ST/PwD)<br />(or)<br />
                                                    • M.Sc from institutions other than IITS

                                                </td>
                                                <td >

                                                Valid GATE score or UGC-NET/CSIR-NET/NBHM/INSPIRE/JEST or equivalent qualification, tenable for the current year in the relevant area.

                                                </td>
                                            </tr>
                                            <tr>
                                                <td >
                                                    <b>
                                                        8<sup>#</sup>
                                                    </b>
                                                </td>
                                                <td >
                                                    B.S/B.E/B.Tech from a Centrally Funded Technical Institute (CFTI) with a minimum CGPA of 8 on 10 point scale (7.5 for EWS/OBC-NCL and 7.0 for SC/ST/PwD).
                                                </td>
                                                <td >
                                                    None
                                                </td>
                                            </tr>
                                            <tr>
                                                <td >
                                                    <b>
                                                        9<sup>#</sup>
                                                    </b>
                                                </td>
                                                <td >
                                                    B.S/B.E/B.Tech from a CFTI without minimum CGPA 8 on a 10 point scale (7.5 for EWS/OBC-NCL and 7.0 for SC/ST/PwD).
                                                </td>
                                                <td >
                                                    Valid GATE score
                                                </td>
                                            </tr>
                                            <tr>
                                                <td >
                                                    <b>
                                                        10<sup>#</sup>
                                                    </b>
                                                </td>
                                                <td >
                                                    B.E/BTech from any other university, with a minimum CGPA of 8.0 on a 10.0 point scale (7.5 for EWS/OBC-NCL and 7.0 for SC/ST/PwD)
                                                </td>
                                                <td >
                                                    Valid GATE score
                                                </td>
                                            </tr>
                                            <tr>
                                                <td rowSpan="1" valign="middle">
                                                    <b>
                                                        Humanities and Social Sciences
                                                    </b>
                                                </td>
                                                <td >
                                                    <b>
                                                        11
                                                    </b>
                                                </td>
                                                <td >
                                                    Master’s degree/dual-degree or equivalent in a relevant discipline
                                                </td>
                                                <td >

                                                Qualifying UGC-NET/CSIR-NET/ GATE score or equivalent qualification, tenable for the current year in the relevant area or an international-level post graduate admission examination such as GRE.<br /><br />Candidates with only a GRE (or equivalent international-level post graduate admission examination) score are not eligible for HTRA.

                                                </td>
                                            </tr> */}
                                            {/* <tr>
                                                <td colSpan="4" >
                                                    # Candidates with Educational Qualifications as mentioned in the S.No. 3,4,5,8,9,10 will be considered for Direct Ph.D.

                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan="4" >
                                                    Note: A valid GATE score or UGC/CSIR-NET/INSPIRE/NBHM qualification etc. is not required in the case of candidates applying under the external/part-time/internal staff category. 
                                                    
                                                </td>
                                            </tr> */}
                                            {/* <tr>
                                                <td colSpan="3" >
                                                * The candidates can only be admitted under the Regular-Project category without eligibility for conversion to the Regular- HTRA.

                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan="3" >
                                                # Candidates with Educational Qualifications as mentioned in S. No. 4 and 5 will be considered for Direct MS(R)+PhD.
                                                    
                                                </td>
                                            </tr> */}
                                        </tbody>

                                        
                                    </Table>

                              
                                        <h5 className='mt-3 mb-3'>Minimum Qualifications for candidates in Part-Time:</h5>
                                  
                                            <p class="caboutus">The educational qualifications remain the same as those prescribed for the full time admission. However, a valid GATE score or UGC-NET/CSIR-NET/INSPIRE/NBHM/JEST or an equivalent qualification as applicable for the full time admission is not required. In addition, applicants under Part Time have to satisfy the following criteria:</p>
											<ul className='myulcustarrow caboutus'>
                                        <li> The applicant must be employed in an industry, organization or institution located within commutable distance of IIT Tirupati.</li>
                                        <li> The applicant should have at least two years of professional experience as on the last date of receipt of applications.</li>
                                    </ul>

                                    {/* <h5 className='mt-3 mb-3'> External:</h5>

                                        <ul className='myulcustarrow caboutus'>
                                                <li>The applicant must be regular employee and have at least two years of professional experience as on the last date of receipt of applications.</li>
                                                <li> The applicant must be sponsored by and employed in an industry/organization/national laboratories, having R&D facilities and recognized by DST/DSIR or having an MoU with IIT Tirupati.</li>
                                        </ul> */}

                                    {/* <h5 className='mt-3 mb-3'>Part-Time:</h5> */}

                                    

                                    {/* <h5 className='mt-3 mb-3'>Internal (IIT Tirupati Staff):</h5>
                                    <ul className='myulcustarrow caboutus'>
                                        <li> The applicant must be a regular employee of IIT Tirupati.</li>
                                        <li> The applicant should have atleast two years of experience as a regular employee as on the last date of receipt of applications.</li>
                                    </ul> */}
                                   <p class="caboutus">All the applicants are requested to go through the Ordinances of Ph.D. programme thoroughly before applying.</p>
                                </div>
                            </Fade>
                            }
                        </div>

                        {/*Fiancial  Assistance*/}

                        <div>
                           {financialOpen && <Fade in={financialOpen}>
                                <div>
                                    <h4 className='mb-4'>For Full Time Ph.D. Candidates:</h4>
                                    {/* <p>
                                    Financial assistance will be provided as per Ministry of Education (MoE) norms. All full time regular scholars admitted to Ph.D. and M.S (Research) programs are eligible for the Half-time Research Assistantship (HTRA) for which:
                                    </p> */}
                                    <ul className='myulcustarrow'>
                                        <li>
											Fellowship: ₹46,250 per month in 1st & 2nd year and ₹52,500 per month in 3rd,4th and 5th years of Ph.D. (support till Ph.D. completion or 5 years whichever is earlier).                                        </li>
                                        <li>
											Research Contingency Grant Support:  An amount of ₹1,20,000/Year/Full-time PhD candidate for support duration of PhD candidate is provided as per scheme guidelines.                                        </li>
                                    </ul>
									<h4 className='mb-4'>For Part Time Ph.D. Candidate:</h4>
                                    {/* <p>
                                    Financial assistance will be provided as per Ministry of Education (MoE) norms. All full time regular scholars admitted to Ph.D. and M.S (Research) programs are eligible for the Half-time Research Assistantship (HTRA) for which:
                                    </p> */}
                                    <ul className='myulcustarrow'>
                                        <li>
											Fellowship @ ₹3,00,000 Lakh on PhD Completion
                                        </li>
                                        <li>
											For other details and benefits, please refer to the scheme guidelines:<Link className="c-link" to="https://tinyurl.com/44p3crsy" target="_blank">Click Here</Link>
                                        </li>
                                    </ul>
                                </div>
                            </Fade>
                            }
                        </div>


                        {/*Section*/}

                        <div>
                        {sectionOpen && <Fade in={sectionOpen}>
                                <div>
                                    <h4 className='mb-4'>Selection Procedure</h4>
                                    <p class="caboutus">The selection committee will call eligible candidates based on the minimum eligibility requirements and additional screening criteria for a written test (if any) and interview.</p>
                                </div>
                            </Fade>}
                        </div>


                        {/*Documents*/}

                        <div>
                        {documentsOpen && <Fade in={documentsOpen}>
                                <div>
                                    <h4 className='mb-4'>Original Documents to be submitted for Verification:</h4>
                                    <p>
                                        <b>At the time of Interview and/or Written Test:</b>
                                    </p>
                                    <p>Self-attested copies of the following documents must be submitted at the time of interview and/or written test.</p>
                                    <ul className='myulcustarrow'>
                                        <li>
                                             Copy of application
                                        </li>
                                        <li>
                                        Degree certificates / Provisionals / Course completion certificates / Grade Cards / Marksheets of all the degrees obtained.
                                        </li>
                                        <li>
                                        Community Certificate in the case of SC/ST/OBC-NCL/EWS candidates issued by the Competent Authority in the prescribed GoI format.
                                        </li>
                                        <li>
                                        Authorized Doctor’s Certificate with disability descriptions in the case of Person with Disabled (PwD) candidates.
                                        </li>
                                        <li>
                                        Copy of GATE score or CSIR-UGC-JRF/LS/NET/DAE-JEST or any other fellowship award.
                                        </li>
                                        {/* <li>
                                        Candidates applying under External Category must produce
                                            <Link className='c-link' to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/NoC_External_Parttime.docx">No Objection Certificate - Click Here</Link>
                                        </li> */}

                                        <li>
                                        Candidates applying under Part-Time Category must produce
                                            <Link className='c-link' to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/NoC_External_Parttime.docx">No Objection Certificate - Click Here</Link>
                                        </li>

                                        {/* <li>
                                            Candidates applying under Internal Category must produce : No Objection Certificate
                                        </li> */}


                                    </ul>
                                    <p className='text-primary'><em>
                                    Important: Please note that the originals of all the above certificates should be produced at the time of physical verification.</em>
                                    </p>
                                    <p>
                                        <b>At the time of Admission:</b>
                                    </p>
                                    <p>Self-attested copies of the following documents must be submitted at the time of admission / registration</p>
                                    <ul className='myulcustarrow'>
                                        <li>
                                             Offer of admission.
                                        </li>
                                        <li>
                                             Birth Certificate / SSC / SSLC certifcate as proof of Name and Date of birth
                                        </li>
                                        <li>
                                             Any valid government ID proof such as Aadhaar, PAN, Passport, Driving License, etc.
                                        </li>
                                        <li>
                                             Degree certificates / Provisionals / Course completion certificates / Grade Cards / Marksheets of all the degrees obtained.
                                        </li>
                                        <li>
                                             Community Certificate in the case of SC/ST/OBC-NCL/EWS candidates issued by the Competent Authority in the prescribed GoI format.
                                        </li>
                                        <li>
                                             Degree certificates / Provisionals / Course completion certificates / Grade Cards / Marksheets of all the degrees obtained.
                                        </li>
                                        {/* <li>
                                             Candidates admitted under External category must also produce:
                                            <ol className='ms-3'>
                                                <li>
                                                No Objection Certificate for using Research Facilities on the employer’s premises. <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/NoC_External_Parttime.docx" target="_blank" className='c-link'>(Link)</Link>
                                                </li>
                                                <li>
                                                Consent of Co-supervisor from the parent organization in case of external candidates. <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/Co-Supervisor_Particulars.docx" target="_blank" className='c-link'>(Link)</Link>
                                                </li>
                                                <li>
                                                Relieving order from the employer <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/Relieving_Certificate.docx" target="_blank" className='c-link'>(Link)</Link>
                                                </li>
                                                
                                            </ol>
                                        </li> */}

                                        <li>Candidates admitted under Part-Time category must also produce: 
                                        <ol className='ms-3'>
                                            <li>
                                            Relieving order from the employer <Link to="https://files.iittp.ac.in/pdfs/admissions/2024/sep/Relieving_Certificate.docx" target="_blank" className='c-link'>(Link)</Link>
                                            </li>
                                        </ol></li>
                                    </ul>
                                    <p className='text-primary'><em>
                                    Important: Please note that the originals of all the above certificates should be produced at the time of physical verification.</em>
                                    </p>
                                </div>
                            </Fade> }
                        </div>

{/*Section*/}

                        <div>
                            {feesOpen && <Fade in={feesOpen}>
                                <div>
                                    <h4 className='mb-4'>Fees and Deposits</h4>
                                    <p >The applicable tuition and other fee/ deposits for Ph.D. scholars is available at the following <Link to="/fee-structure" className='c-link'>link</Link>.</p>
                                </div>
                            </Fade> }
                        </div>
{/*Apply Online*/}

                        <div>
                            {applyonlineOpen && <Fade in={applyonlineOpen}>
                                <div>
                                    <h4 className='mb-4'>Apply Online</h4>
                                    <p><b>To Apply Online</b> : <Link to="https://iittp.plumerp.co.in/prod/iittirupati/phdregistration.php" className='c-link'><b>https://iittp.plumerp.co.in/prod/iittirupati/phdregistration.php</b></Link> </p>
									<p className="c-link glowing-text">Due to technical issues, the admissions portal is temporarily unavailable. We are working to restore the services at the earliest. We regret the inconvenience caused. Kindly try again after some time. </p>

                                     {/* <p><b>To login and download application</b> : <Link to="https://iittp.plumerp.co.in/prod/iittirupati/phdapplication.php" target="_blank" className='c-link'><b>Click Here</b></Link>
                                    </p> */}

                                </div>
                            </Fade> }
                        </div>


                    </Col>

                </Row>
            {/* </> */}
            </Container>
        </section>
    );
}

export default Visvesvaraya_Phd_AdmissionELe;
